// src/pages/Privacy.jsx
import React from 'react';
import { Box, Typography, Stack, alpha, Container } from '@mui/material';
import { Link } from 'react-router-dom';

export default function Privacy() {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#0f1419', py: { xs: 4, md: 8 }, px: 2 }}>
      <Container maxWidth="md">
        <Stack spacing={3}>
          <Link to="/login" style={{ color: '#00d4ff', textDecoration: 'none', fontSize: '0.875rem' }}>
            ← Back to TradeWave
          </Link>
          <Typography variant="h3" sx={{ color: '#fff', fontWeight: 800 }}>
            Privacy Policy
          </Typography>
          <Typography variant="body2" sx={{ color: alpha('#fff', 0.5) }}>
            Last updated: {new Date().toISOString().slice(0, 10)}
          </Typography>
          <Box sx={{
            p: 3,
            bgcolor: alpha('#1a1f2e', 0.6),
            border: `1px solid ${alpha('#00d4ff', 0.15)}`,
            borderRadius: 2,
          }}>
            <Typography sx={{ color: alpha('#fff', 0.85), lineHeight: 1.7, mb: 2 }}>
              TradeWave does not sell, trade, or rent your personal information. The data we collect — login credentials, trading configurations, signal history, and analytics — is used solely to operate the platform.
            </Typography>
            <Typography sx={{ color: alpha('#fff', 0.85), lineHeight: 1.7, mb: 2 }}>
              Trading signals and strategy data are stored on infrastructure controlled by TradeWave and are accessible only to authenticated users with appropriate roles.
            </Typography>
            <Typography sx={{ color: alpha('#fff', 0.85), lineHeight: 1.7 }}>
              For questions about your data or to request deletion, contact the TradeWave administrator.
            </Typography>
          </Box>
        </Stack>
      </Container>
    </Box>
  );
}
